<ion-content class="non-garments">
  <app-header [title]="(routeStopName ?? '') + ' (' + stopName + ') : Non-Garments'" [breadcrumbs]="breadcrumbs"></app-header>
  <ng-container>
    <ion-grid style=" padding-top:100px">
      <div class="div-container" *ngIf="loaded">
        <ion-row class="align">
          <ion-header>Delivery List</ion-header>
        </ion-row>
        <ion-row>
          <div class="table-row" *ngIf="loaded">
            <ngx-datatable
              class="bootstrap"
              [rows]="deliveryList"
              [rowHeight]="50"
              [sortType]="'multi'"
              [headerHeight]="50"
              [footerHeight]="50"
              [columnMode]="'force'"
              [scrollbarH]="false"
            >
              <ngx-datatable-column
                name="Product"
                prop="routeDeliveryDetail.productCode"
              >
                <ng-template ngx-datatable-cell-template let-value="value">
                  <a><span class="productCode"></span>&nbsp;{{value}}</a>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column
                name="Weeks"
                prop="routeDeliveryDetail.week"
              >
                <ng-template ngx-datatable-cell-template let-value="value">
                  <a class="weeks">{{value}}</a>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column
                name="Total Inv"
                prop="routeDeliveryDetail.productQuotaHalf"
              >
                <ng-template ngx-datatable-cell-template let-value="value">
                  <a class="productQuota">{{value}}</a>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column
                name="Del. Qty"
                prop="routeDeliveryDetail.productLastUsedQty"
              >
                <ng-template ngx-datatable-cell-template let-value="value">
                  <a class="productLastUsedQty">{{value}}</a>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </ion-row>

        <ion-row class="align">
          <ion-header *ngIf="!productsWarningFlag"
            >Products to Service Today</ion-header
          >
          <ion-header *ngIf="productsWarningFlag"
            >Pick Up List
            <span style="color: red"
              >Warning Some Counts Not Entered</span
            ></ion-header
          >
        </ion-row>
        <ion-row class="products-service">
          <div class="table-row" *ngIf="loaded">
            <ngx-datatable
              class="bootstrap"
              [rows]="productsServiceList"
              [rowHeight]="50"
              [sortType]="'multi'"
              [headerHeight]="50"
              [footerHeight]="50"
              [columnMode]="'force'"
              [scrollbarH]="false"
            >
              <ngx-datatable-column name="Department" prop="departmentCode">
                <ng-template
                  ngx-datatable-cell-template
                  let-row="row"
                  let-value="value"
                >
                  <a><span class="departmentCode"></span>&nbsp;{{value}}</a>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Product" prop="productCode">
                <ng-template ngx-datatable-cell-template let-value="value">
                  <a class="productCode">{{value}}</a>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Quantity" prop="qty">
                <ng-template
                  ngx-datatable-cell-template
                  let-value="value"
                  let-row="row"
                >
                  <input
                    type="number"
                    [value]="value"
                    (input)="editQuantity($event, row)"
                  />
                </ng-template>
              </ngx-datatable-column>
               
            </ngx-datatable>
          </div>
          <ion-button [disabled]="processingRequest" style="--background: #006633;" class="service-button" (click)="saveProducts()"
            >Save</ion-button
          >
        </ion-row>
        <ion-row class="align">
          <ion-header>Off Week Products</ion-header>
        </ion-row>
        <ion-row>
          <div class="table-row">
            <ngx-datatable
              class="bootstrap"
              [limit]="5"
              [rows]="offWeekProducts"
              [rowHeight]="50"
              [sortType]="'multi'"
              [headerHeight]="50"
              [footerHeight]="50"
              [columnMode]="'force'"
              [scrollbarH]="false"
            >
              <ngx-datatable-column
                name="Product"
                prop="productCode"
              ></ngx-datatable-column>
              <ngx-datatable-column
                name="Weeks"
                prop="frequency"
              ></ngx-datatable-column>
              <ngx-datatable-column
                name="Planned Quantity"
                prop="quota"
              ></ngx-datatable-column>
            </ngx-datatable>
          </div>
        </ion-row>
      </div>
      <div class="loading-container" *ngIf="!loader">
        <ion-spinner></ion-spinner>
      </div>
    </ion-grid>
  </ng-container>
</ion-content>
